import BlockRegistry from '../../BlockRegistry';

export function registerDHTSensor() {
    BlockRegistry.register('dhtSensor_dht_read', (block, context) => {
        const pin = context.getInputValue(block, 'PIN');
        const type = context.getInputValue(block, 'TYPE') || 'Temperature'; // 'Temperature' or 'Humidity'
        
        context.addInclude('#include <DHT.h>');
        context.addInclude('#define DHTTYPE DHT11');
        
        const dhtName = `dht_${pin}`;
        context.addGlobal(dhtName, `DHT ${dhtName}(${pin}, DHTTYPE);`);
        context.addSetup(`${dhtName}.begin();`);
        
        return `${dhtName}.read${type}()`;
    });
}
